import type { Locale } from 'date-fns';

export const getFnsLocale = async (locale: string): Promise<Locale> =>
  import(
    /* webpackExclude: /_lib/, webpackMode: "lazy", webpackChunkName: "df-[index]" */ `date-fns/locale/${locale}/index.js`
  );
